import {Result} from "antd-mobile";

export default function ERR503() {


    return <>      <Result
        status='error'
        title='503'
    /></>
}